export default __webpack_public_path__ + "static/media/orange-leaf.cd84e6b0.png";